var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.showComponent,{tag:"component",attrs:{"uri":_vm.uriState,"animationUrl":_vm.animationURLState,"files":_vm.filesState,"preview":_vm.preview,"artView":_vm.artView,"active":_vm.active}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }